import { useState, useEffect } from "react";
import { getCookie } from "../utils/cookieUtils";

function useAdminBatchDetailsGet() {
  const [batchNames, setBatchNames] = useState([]);

  const [spreadsheetLink, setSpreadsheetLink] = useState([]);
  const [study, setStudy] = useState([]);
  const [noOfUsers, setNoOfUsers] = useState([]);
  const [status, setStatus] = useState([]);
  const [fileUploadStatus, setFileUploadstatus] = useState([]);
  const [usersAdded, setUsersAdded] = useState([]);
  const [usersStatus, setUsersStatus] = useState([]);
  const [batchInstructions, setBatchInstructions] = useState([]);
  const [batchInstructionsList, setBatchInstructionsList] = useState([]);
  const [randomizeFilePlayback, setRandomizeFilePlayback] = useState([]);
  const [numberOfUsers, setNumberOfUsers] = useState([]);
  const [fileMultiSign, setFileMultiSign] = useState([]);
  const [batchId, setBatchId] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/percept_db/v1/manage-user-batches`, {
      method: 'GET',
      headers: {
        'X-Spl-Username-Header': getCookie('X-Spl-Username-Header'),
      },
    })    
      .then((response) => response.json())
      .then((data) => {
        const batchId = data.data.batch_details.map(
          (batch) => batch.batch_id
        );
        setBatchId(batchId);
        const batchNames = data.data.batch_details.map(
          (batch) => batch.batch_name
        );
        setBatchNames(batchNames);
        console.log();
        const spreadsheetLink = data.data.batch_details.map(
          (batch) => batch.spreadsheet_link
        );
        setSpreadsheetLink(spreadsheetLink);
        const study = data.data.batch_details.map(
          (batch) => batch.study
        );
        setStudy(study);
        const noOfUsers = data.data.batch_details.map(
          (batch) => batch.number_of_users
        );
        setNoOfUsers(noOfUsers);
        const status = data.data.batch_details.map((batch) => batch.status);
        setStatus(status);
        const fileUploadStatus = data.data.batch_details.map(
          (batch) => batch.file_upload_status
        );
        setFileUploadstatus(fileUploadStatus);
        const usersAdded = data.data.batch_details.map((batch) => batch.users_added);
        setUsersAdded(usersAdded);
        const usersStatus = data.data.batch_details.map((batch) => batch.users_status);
        setUsersStatus(usersStatus);

        const batchInstructions = data.data.batch_details.map(
          (batch) => batch.batch_instruction
        );
        setBatchInstructions(batchInstructions);

        const randomizeFilePlayback = data.data.batch_details.map(
          (batch) => batch.randomize_file_playback
        );
        setRandomizeFilePlayback(randomizeFilePlayback);

        const numberOfUsers = data.data.batch_details.map(
          (batch) => batch.number_of_users
        );
        setNumberOfUsers(numberOfUsers);

        const fileMultiSign = data.data.batch_details.map(
          (batch) => batch.file_multiassign_percentage
        );
        setFileMultiSign(fileMultiSign);

        const batchInstructionsList = data.data.batch_details.map(
          (batch) => batch.batch_instructions_list
        );
        setBatchInstructionsList(batchInstructionsList);
      })
      .catch((error) => console.log("Excepted!"));
  }, []);

  return {
    batchId,
    batchNames,
    spreadsheetLink,
    study,
    noOfUsers,
    status,
    fileUploadStatus,
    usersAdded,
    usersStatus,
    batchInstructions,
    batchInstructionsList,
    randomizeFilePlayback,
    numberOfUsers,
    fileMultiSign,
  };
}

export default useAdminBatchDetailsGet;
